import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import {getAccountHeadList, getGroupList, createGroupItem, ledgerGroupList, getLedgerGrpById as findLedgerGrpId, getLedgerDependencyData} from "../services/Ledgers.Service"

export const getAccountList = createAsyncThunk("ledger/accounts", async ()=>{
  const data =  await getAccountHeadList();
  return data;
})

export const getLedgerGroupList = createAsyncThunk("ledger/ledger-group-list", async (ledgerGroupId, thunkAPI)=>{
  try{
    const accounts =  await getGroupList(ledgerGroupId);
    
    return accounts;
  }catch(err){
    console.log(err.response)
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }
})

export const createLedgerGroup = createAsyncThunk("ledger/createledgerGroup", async (formData, thunkAPI)=>{
  try{
    const response =  await createGroupItem(formData);
    return response;
  }catch(err){
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }
 
})

export const getLedgerGroupData = createAsyncThunk("ledger/ledgerGroupList", async (params, thunkAPI)=>{
  try{
    const response =  await ledgerGroupList(params);
    return response;
  }catch(err){
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }
})

export const getLedgerGrpById = createAsyncThunk("ledger/getLedgerDetailsById", async (grpId, thunkAPI)=>{
  try{
    const response =  await findLedgerGrpId(grpId);
    return response;
  }catch(err){
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }
})

export const getLedgerDependency = createAsyncThunk("ledger/getLedgerDependency", async (params,thunkAPI)=>{
  try{
    const response =  await getLedgerDependencyData(params);
    return response.data;
  }catch(err){
    console.log(err.response)
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }
})

const processAccountHeadHierarchy = {
      levelOpt:[],
      selectedValue:[],
      getLevelOpt: function(children){
          if(children){
            for( let value of children ){
                let level = value['level'] - 1
                
                if(typeof this.levelOpt[level] === "undefined"){
                  this.levelOpt[level] = []
                }
                let obj = JSON.parse(JSON.stringify(this.levelOpt))
                this.levelOpt = obj

                this.levelOpt[level].push(value)
                
             
                if(value.children){
                  this.getLevelOpt(value.children)
                }
            }
          }
          return this.levelOpt
      }
}

const initialState = {
  groupList:[],
  accountHead : [],
  levelOpt:[],
  grpData:[],
  currentLevel:0,
  success:false,
  isDataSaveSuccess:false,
  dependencyData:[],
  error:false,
  loading:false,
  message:"",
}

const LedgerSlice = createSlice({
  name: "Ledgers",
  initialState,
  reducers:{
    reset: () => initialState,
    setCurrentLevel:(state, action)=> {
      state.currentLevel = action.payload.level
    },
    removeLevel:(state, action) => {
      let levelOpt = JSON.parse(JSON.stringify(state.levelOpt));
      let arrKey = state.currentLevel - 1
      levelOpt.splice(arrKey, (state.levelOpt.length - arrKey))
      console.log(levelOpt)
      state.levelOpt = levelOpt
    }
  },
  extraReducers:{
    [getAccountList.pending]:(state)=>{
      state.loading = true
      state.error = false;
    },
    [getAccountList.rejected]:(state, action)=>{
      state.loading = false
      state.error = action.payload?.message;
    },
    [getAccountList.fulfilled]:(state, action) => {
      state.loading = false
      state.success = action.payload.success;
      state.accountHead = action.payload.data
    },

    [getLedgerGroupList.pending]:(state)=>{
      state.loading = true
      state.error = false;
    },
    [getLedgerGroupList.rejected]:(state, action)=>{
      state.loading = false
      console.log(action)
      state.error = action.payload?.message;
    },
    [getLedgerGroupList.fulfilled]:(state, action) => {
      state.loading = false
      state.success = action.payload.success;
      let levelOpt = JSON.parse(JSON.stringify(state.levelOpt));
      let arrKey = state.currentLevel - 1
      if(action.payload.data.length > 0){
        levelOpt[arrKey] = action.payload.data  
      }
      state.levelOpt = levelOpt
    },

    [createLedgerGroup.pending]:(state)=>{
      state.loading = true
      state.error = false;
    },
    [createLedgerGroup.rejected]:(state, action)=>{
      console.log(action.payload)
      state.loading = false
      state.error = action.payload?.error;
    },
    [createLedgerGroup.fulfilled]:(state, action) => {
      state.loading = false
      state.isDataSaveSuccess = action.payload.success;
      state.message = action.payload.data
    },

    [getLedgerGroupData.pending]:(state)=>{
      state.loading = true
      state.error = false;
    },
    [getLedgerGroupData.rejected]:(state, action)=>{
      state.loading = false
      state.error = action.payload?.error;
    },
    [getLedgerGroupData.fulfilled]:(state, action) => {
      state.loading = false
      state.success = action.payload.success;
      state.groupList = action.payload.data
    },

    [getLedgerGrpById.pending]:(state)=>{
      state.loading = true
      state.error = false;
    },
    [getLedgerGrpById.rejected]:(state, action)=>{
      state.loading = false
      state.error = action.payload?.error;
    },
    [getLedgerGrpById.fulfilled]:(state, action) => {
      state.loading = false
      state.success = action.payload.success;
      let obj = Object.create(processAccountHeadHierarchy);
      state.levelOpt = obj.getLevelOpt(action.payload.data?.accountHeadHierarchy?.children);
      state.grpData = action.payload.data
    },
    
    [getLedgerDependency.pending]:(state)=>{
      state.loading = true
      state.error = false;
    },
    [getLedgerDependency.rejected]:(state, action)=>{
      state.loading = false
      state.error = action.payload?.error;
    },
    [getLedgerDependency.fulfilled]:(state, action) => {
      state.loading = false
      state.success = action.payload.success;
      let dependencyData =  current(state.dependencyData)
      dependencyData = {...dependencyData, ...action.payload.data}
      state.dependencyData = dependencyData
    },

  }
});

export const {setCurrentLevel, removeLevel, reset} = LedgerSlice.actions

export default LedgerSlice.reducer